import React from "react";

export const EyeClosed = (): JSX.Element => (
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
    <g
      stroke="#C4C4C6"
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2.5 7.5s2.5 4 7.5 4 7.5-4 7.5-4M10 12v2M13 11l1 2M16 10l1 1M4 10l-1 1M7 11l-1 2" />
    </g>
  </svg>
);

export const EyeOpen = (): JSX.Element => (
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
  >
    <defs>
      <circle id="a" cx="10" cy="9" r="4" />
      <mask
        id="b"
        maskContentUnits="userSpaceOnUse"
        maskUnits="objectBoundingBox"
        x="0"
        y="0"
        width="8"
        height="8"
        fill="#fff"
      >
        <use xlinkHref="#a" />
      </mask>
    </defs>
    <g stroke="#C4C4C6" fill="none" fillRule="evenodd">
      <path
        d="M2.5 10S5 14.5 10 14.5s7.5-4.5 7.5-4.5M2.5 10S5 5.5 10 5.5s7.5 4.5 7.5 4.5"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <use mask="url(#b)" strokeWidth="4" xlinkHref="#a" />
    </g>
  </svg>
);
